import React, { useState } from "react";
import { Box, Button, Card, useMediaQuery } from "@mui/material";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import { CardMedia } from "@mui/material";

import FoneEnero from "../assets/images/Calendars/FoneEnero.png";
import FoneFebrero from "../assets/images/Calendars/FoneFebrero.png";
import FoneMarzo from "../assets/images/Calendars/FoneMarzo.png";
import FoneAbril from "../assets/images/Calendars/FoneAbril.png";

import FoneMayo1 from "../assets/images/Calendars/FoneMayo1.png";
import FoneMayo2 from "../assets/images/Calendars/FoneMayo2.png";
import FoneJunio from "../assets/images/Calendars/FoneJunio.png";
import FoneJulio from "../assets/images/Calendars/FoneJulio.png";

import { motion } from "framer-motion";

const cards = [
  { image: FoneEnero },
  { image: FoneFebrero },
  { image: FoneMarzo },
  { image: FoneAbril },
  { image: FoneMayo1 },
  { image: FoneMayo2 },
  { image: FoneJunio },
  { image: FoneJulio },
];

const MotionBox = motion(Box);

const CarruselFONE = () => {
  const [startIndex, setStartIndex] = useState(0);
  const isSmallScreen = useMediaQuery("(max-width:768px)");
  const isLaptopOrLarger = useMediaQuery("(min-width:1024px)");

  const nextCards = () => {
    if (startIndex + 1 < cards.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const prevCards = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  return (
    <MotionBox
      sx={{ textAlign: "center", mt: 4 }}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: isSmallScreen ? "column" : "row",
          gap: isSmallScreen ? 2 : 0,
          width: "100%",
          margin: "0 auto",
        }}
      >
        <Button
          onClick={prevCards}
          variant="contained"
          disabled={startIndex === 0}
          sx={{
            backgroundColor: "#ca0c12",
            color: "white",
            borderRadius: "10px",
            "&:hover": { color: "white", backgroundColor: "#970005" },
            padding: isSmallScreen ? "10px" : "0px 20px",
            height: isSmallScreen
              ? "auto"
              : isLaptopOrLarger
              ? "500px"
              : "100%", // Ajuste de altura en pantallas grandes
            width: isSmallScreen ? "100%" : "auto",
            minWidth: "50px",
          }}
        >
          <FaArrowLeft color="white" />
        </Button>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: isSmallScreen ? "100%" : "auto",
          }}
        >
          {cards.slice(startIndex, startIndex + 1).map((card, index) => (
            <Card
              key={index}
              sx={{
                width: isSmallScreen ? "100%" : "600px",
                maxWidth: "100%",
                textAlign: "center",
                boxShadow: 3,
                height: "auto",
                maxHeight: "600px",
              }}
            >
              <CardMedia
                component="img"
                image={card.image}
                sx={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                }}
              />
            </Card>
          ))}
        </Box>

        <Button
          onClick={nextCards}
          variant="contained"
          disabled={startIndex + 1 >= cards.length}
          sx={{
            backgroundColor: "#ca0c12",
            color: "white",
            borderRadius: "10px",
            "&:hover": { color: "white", backgroundColor: "#970005" },
            padding: isSmallScreen ? "10px" : "0px 20px",
            height: isSmallScreen
              ? "auto"
              : isLaptopOrLarger
              ? "500px"
              : "100%",
            width: isSmallScreen ? "100%" : "auto",
            minWidth: "50px",
          }}
        >
          <FaArrowRight color="white" />
        </Button>
      </Box>
    </MotionBox>
  );
};

export default CarruselFONE;
